module.exports = __webpack_public_path__ + "static/media/diagram.a8c97390.png";